export type DevIndicatorServerState = typeof devIndicatorServerState

export const devIndicatorServerState = {
  disabledUntil: 0,
}
